import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Repeat, Loader2 } from "lucide-react";

export const EquivalentesDialog = ({ item, onClose, onSustituir }) => {
  const [equivalentes, setEquivalentes] = useState(null);

  useEffect(() => {
    if (!item) { setEquivalentes(null); return; }
    api.get(`/repuestos/${item.repuesto_id}/equivalentes`)
      .then((r) => setEquivalentes(r.data))
      .catch(() => setEquivalentes([]));
  }, [item]);

  return (
    <Dialog open={!!item} onOpenChange={onClose}>
      <DialogContent className="bg-white max-w-lg">
        <DialogHeader>
          <DialogTitle>Repuestos equivalentes</DialogTitle>
          <DialogDescription className="text-xs">
            Sustitutos intercambiables de <span className="font-mono font-semibold">{item?.codigo_parte}</span> — {item?.nombre}. Se conservará la cantidad ({item?.cantidad}).
          </DialogDescription>
        </DialogHeader>
        {equivalentes === null && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground py-4">
            <Loader2 size={14} className="animate-spin" /> Buscando equivalentes...
          </div>
        )}
        {equivalentes?.length === 0 && (
          <p className="text-sm text-muted-foreground py-4">Este repuesto no tiene equivalentes registrados.</p>
        )}
        <div className="space-y-1 max-h-72 overflow-y-auto">
          {equivalentes?.map((eq) => (
            <div key={eq.id} data-testid={`equivalente-${eq.codigo_parte}`}
              className="flex items-center gap-2 border border-border rounded-sm px-3 py-2">
              <div className="flex-1 min-w-0">
                <div className="text-sm"><span className="font-mono font-semibold text-xs">{eq.codigo_parte}</span> — {eq.nombre}</div>
                {eq.compatibilidad && <div className="text-xs text-muted-foreground truncate">{eq.compatibilidad}</div>}
              </div>
              <Button data-testid={`sustituir-por-${eq.codigo_parte}`} size="sm" onClick={() => onSustituir(eq)}>
                <Repeat size={13} className="mr-1" /> Sustituir
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
